import superagent from '@ott/superagent';
import trackError from '../trackError';

import { Payload } from './types';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const checkCaptcha = createAsyncThunk<void, Payload>(
  'auth/checkCaptcha/fetch',
  async ({ value, keys, url }, { rejectWithValue }) => {
    try {
      const {
        body: { result, error },
      } = await superagent.post(url).send({
        keys,
        captchaResponse: value,
      });

      if (!result) {
        throw Error('empty result');
      }
    } catch (e) {
      trackError(e);

      if (e instanceof Error) {
        return rejectWithValue(e.message);
      }
    }
  }
);
